/**
 * All APIs for the application
 */
const API = {};

API.GET_COMPANY_INFO = 'GetCompanyHotel?url=';
API.GET_CONFIG='/config.json';
export default API
